import { DialogTrigger } from "react-aria-components";

export const PopupDialogTrigger = DialogTrigger;
